import { gql } from "@apollo/client";

export const MANUFACTURERS_QUERY = gql`
  query MasterManufacturers {
    masterManufacturers {
        id
        name
        countryCode
        country
        website
        contactEmail
        phoneNumber
        description
        isActive
        contactPerson
        address
        createdAt
        updatedAt
        deletedAt
    }
}
`;

// Vendors Query

export const VENDORS_QUERY = gql`
  query MasterVendors {
    masterVendors {
        id
        company_name
        website
        email
        name
        phone_number
        country_code
        vendor_type
        can_login
        invited_by_user
        created_at
        updated_at
    }
}
`;

// Asset Categories Query

export const PODUCT_CATEGORIES_QUERY = gql`
 query ProductCategories {
    productCategories {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
        parent {
            id
            parentId
            name
            description
            isActive
            iconName
            iconColor
            iconType
            createdAt
            updatedAt
            deletedAt
        }
        children {
            id
            parentId
            name
            description
            isActive
            iconName
            iconColor
            iconType
            createdAt
            updatedAt
            deletedAt
        }
        entityMetadata {
            id
            entityId
            coverage
        }
    }
}
`;

export const PRODUCT_CATEGORY_QUERY = gql`
  query ProductCategory($id: ID!) {
    productCategory(id: $id) {
      id
      parentId
      name
      description
      isActive
      iconName
      iconColor
      iconType
      createdAt
      updatedAt
      deletedAt
      parent {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
      }
      children {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
      }
      entityMetadata {
        id
        coverage
      }
    }
  }
`;

export const WORKORDER_STAGES_QUERY = gql`
 query MasterWorkOrderStages {
    masterWorkOrderStages {
        id
        name
        color_code
        is_default
        display_order
        created_at
        updated_at
    }
}
`;

export const MASTER_DOCUMENT_TYPES_QUERY = gql`
  query MasterDocumentTypes {
    masterDocumentTypes {
      id
      type
      description
      prompt
      created_at
      updated_at
    }
  }
`;

// Asset Types Query

export const PRODUCT_TYPES_QUERY = gql`query ProductTypes($categoryId: ID, $search: String) {
    productTypes(categoryId: $categoryId, search: $search) {
        id
        categoryId
        parentId
        name
        description
        fieldDefinitions
        isActive
        iconName
        iconType
        iconColor
        groupType
        createdAt
        updatedAt
        deletedAt
        category {
            id
            parentId
            name
            description
            isActive
            iconName
            iconColor
            iconType
            createdAt
            updatedAt
            deletedAt
        }
        entityMetadata {
            id
            entityId
            coverage
        }
    }
}

`;

export const PRODUCT_TYPE_QUERY = gql`
  query ProductType($id: ID!) {
    productType(id: $id) {
      id
      categoryId
      parentId
      name
      description
      fieldDefinitions
      evidenceRequirements
      isActive
      iconName
      iconType
      iconColor
      groupType
      createdAt
      updatedAt
      deletedAt
      category {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
      }
      parent {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
      }
      children {
        id
        categoryId
        parentId
        name
        description
        fieldDefinitions
        isActive
        iconName
        iconType
        iconColor
        groupType
        createdAt
        updatedAt
        deletedAt
      }
      
      entityMetadata {
        id
        coverage
      }
    }
  }
`;

export const PRODUCTS_QUERY = gql`
  query Products($categoryId: ID, $typeId: ID, $manufacturerId: ID, $requested: Boolean) {
    products(categoryId: $categoryId, typeId: $typeId, manufacturerId: $manufacturerId, requested: $requested) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      series
      companyId
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      status
      isActive
       entityMetadata {
            id
            entityId
            coverage
        }
      children {
        id
        parentId
        categoryId
        typeId
        manufacturerId
        successorId
        predecessorId
        name
        make
        model
        serialNumber
        dataSheets
        lifespan
        rating
        specifications
        images
        description
        lifecycleStatus
        manufacturerStatus
        isActive
        createdAt
        updatedAt
        deletedAt
      }
      category {
        id
        parentId
        name
        description
        isActive
        iconName
        iconColor
        iconType
        createdAt
        updatedAt
        deletedAt
      }
      type {
        id
        categoryId
        parentId
        name
        description
        iconName
        iconType
        iconColor
      }
        manufacturer {
            id
            name
        }
    }
  }
`;

// Single Product Query by ID

export const PRODUCT_QUERY = gql`
  query Product($id: ID!) {
    product(id: $id) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      series
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      childIds
      description
      lifecycleStatus
      manufacturerStatus
      status
      companyId
      companyName
      isActive
      createdAt
      updatedAt
      deletedAt
      children {
        id
        parentId
        categoryId
        typeId
        manufacturerId
        successorId
        predecessorId
        name
        make
        model
        series
        serialNumber
        dataSheets
        lifespan
        rating
        specifications
        images
        childIds
        description
        lifecycleStatus
        manufacturerStatus
        status
        companyId
        companyName
        isActive
        createdAt
        updatedAt
        deletedAt
      }
        entityMetadata {
        id
        coverage
      }
    }
  }
`;

export const CREATE_PRODUCT_MUTATION = gql`
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      isActive
    }
  }
`;

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const DELETE_PRODUCT_MUTATION = gql`
  mutation DeleteProduct($input: DeleteProductInput!) {
    deleteProduct(input: $input)
  }
`;

// FAQs Query

export const FAQS_QUERY = gql`
  query MasterFAQs($appliesTo: AppliesTo, $referenceId: ID, $isActive: Boolean) {
    masterFAQs(appliesTo: $appliesTo, referenceId: $referenceId, isActive: $isActive) {
      id
      appliesTo
      referenceId
      reference
      question
      answer
      tags
      displayOrder
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

// Product Service Types Query

export const PRODUCT_SERVICE_TYPES_QUERY = gql`
  query ProductServiceTypes {
    productServiceTypes {
      id
      name
      productCategoryIds
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

// Get File by ID Query

export const PRODUCT_MAINTENANCE_SCHEDULES_QUERY = gql`
    query ProductMaintenanceSchedules($productId: ID!) {
        productMaintenanceSchedules(productId: $productId) {
            id
            productId
            scheduleType
            intervalValue
            intervalUnit
            maintenanceTasks
            requiredParts
            isMandatory
            isActive
            createdAt
            updatedAt
        }
    }
`;

export const PRODUCT_TYPE_GROUP_TYPES_QUERY = gql`
  query ProductTypeGroupTypes {
    productTypeGroupTypes
  }
`;
